import React, { useState, useEffect } from 'react'
import { isValidCPF } from '@byma/shared/helpers/validators'
import Router from 'next/router'
import VMasker from 'vanilla-masker'

export default function SearchInput({ currentQuery, placeholder = "Buscar..." }) {
    const [query, setQuery] = useState(currentQuery || '')
    useEffect(() => setQuery(currentQuery || ''), [currentQuery])

    const handleFilter = (e, forceKey) => {
        e?.preventDefault()
        let key = typeof forceKey === 'string' ? forceKey : query
        let url = new URL(window.location.href)
        if (isValidCPF(key) && key.length === 11 && !key.includes('.')) key = VMasker.toPattern(key, '999.999.999-99')
        key ? url.searchParams.set('q', key) : url.searchParams.delete('q')
        Router.push(url.toString())
    }

    return (
        <div className="flex items-center rounded shadow px-2 py-1 hover:shadow-md whitespace-nowrap space-x-1 focus-within:border-blue-500 transition-all">
            <form onSubmit={handleFilter} role="search" className="flex items-center w-full">
                <button type="submit" aria-label="Pesquisar" className="focus:outline-none">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                    </svg>
                </button>
                <input type="search" className="outline-none text-sm w-56 ml-1 bg-transparent [&::-webkit-search-cancel-button]:appearance-none" placeholder={placeholder} value={query} onChange={e => setQuery(e.target.value)} name="query" aria-label="Buscar"/>
                {query && (
                    <button type="button" onClick={() => { setQuery(''); handleFilter(null, ''); }} aria-label="Limpar">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                )}
            </form>
        </div>
    )
}
